interface SwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  id?: string;
  disabled?: boolean;
}

/** Accessible on/off switch (role="switch") with a botanical track. */
export function Switch({ checked, onChange, label, id, disabled }: SwitchProps) {
  return (
    <span className="cv-switch">
      <input
        type="checkbox"
        role="switch"
        id={id}
        checked={checked}
        disabled={disabled}
        aria-label={label}
        aria-checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="cv-switch__track" aria-hidden="true" />
      <span className="cv-switch__thumb" aria-hidden="true" />
    </span>
  );
}
